module.exports = {
  MICRO: 'micro',
  MINI: 'mini',
  ECONOMY: 'economy',
  COMPACT: 'compact',
  COUPE: 'coupe',
  CONVERTIBLE: 'convertible',
  FAMILY: 'family',
  MOTORBIKE: 'motorbike',
  PICKUP: 'pick-up',
  MINIVAN: 'minivan',
  GRAND_TOURER: 'grand-tourer',
  LUXURY: 'luxury',
  SPECIAL: 'special',
  COMMERCIAL: 'commercial',
};
